<div class="warranty-validation-dialog">
    <h2>Falta completar campos</h2>
    <span>Hay algunos campos obligatorios de su garantía que se encuentran incompletos.<br>Por favor completelos antes de proceder con la creación del contrato.</span>
    <app-data-printer [categories]="generateCategories()"></app-data-printer>
    <div class="buttons">
        <button mat-raised-button color="primary" class="garantor-button mini aceptar" (click)="cerrarDialogo(false)">Cerrar</button>
        <button mat-raised-button color="primary" class="garantor-button mini actualizar" (click)="cerrarDialogo(true)">Actualizar</button>
    </div>
</div>

<ng-template #categoryButtonTemplate let-link="link">
    <div class="free-space"></div>
    <a [routerLink]="link" target="_blank">
        <button mat-raised-button color="accent" class="garantor-button mini">Modificar</button>
    </a>
</ng-template>
